module.exports = __webpack_public_path__ + "img/sync-success.195004e1.png";